import React, { useState, useEffect } from 'react';

import { login, getUser, getUserAgency, getAllAgencies, updatePassword } from '../API';

import { Grid, Avatar, Button } from '@mui/material'

function UserProfile() {

  const btnstyle = { margin: '8px 0' }

  const [pwd1, setPwd1] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [errMsg2, setErrMsg2] = useState('');
  const [alert, setAlert] = useState(0);

  const [agency, setAgency] = useState('');
  const [user, setUser] = useState('');
  const [agencies, setAgencies] = useState([]);

  useEffect(() => {

    getUserAgency()
      .then(response => {
        setAgency(response);
      })

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })

    getUser()
      .then(response => {
        setUser(response.user);
      })

    setAlert(0);

  }, []);


  const handleSubmit = (e) => {

    e.preventDefault();

    if (pwd1 === pwd2) {
      setErrMsg(0);
    } else {
      setErrMsg(1);
    }

    if (containsSpecialChars(pwd1) && containsUppercase(pwd1) && containsNumber(pwd1)
    && containsSpecialChars(pwd2) && containsUppercase(pwd2) && containsNumber(pwd2)) {
      setErrMsg2(0);
    } else {
      setErrMsg2(1);
    }

    if (pwd1 === pwd2 && containsSpecialChars(pwd1) && containsUppercase(pwd1) && containsNumber(pwd1)) {
      // e.target.elements.password1.value = '';
      // e.target.elements.password2.value = '';
      setPwd1('');
      setPwd2('');
      setErrMsg2(0);
      setAlert(1);
      updatePassword(agency, user, pwd1)
        .then(() => {
          return done
        })
    }

  }

  function containsSpecialChars(str) {
    const specialChars =
      '[`!@#$%^&*()_+-=[]{};\':"\\|,.<>/?~]/';
    return specialChars
      .split('')
      .some((specialChar) => str.includes(specialChar));
  }

  function containsUppercase(str) {
    return /[A-Z]/.test(str);
  }

  function containsNumber(str) {
    return /\d/.test(str);
  }

  return (
    <>
      <div className="row justify-content-center ps-1 pe-1">
        <h1 id="page-title" className="display-5">OPTIONS</h1>
      </div>

      <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="row justify-content-center pt-4 pb-4">
          <h3 className="text-center display-7">MODIFIER MON MOT DE PASSE</h3>
          <div className="col-12 text-center">
            <p>Le mot de passe doit contenir au moins un caractère spécial, une majuscule et un chiffre</p>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-4 col-sm-12 pt-4">

            <div className="alert alert-success" role="alert" style={{ visibility: alert == 1 ? "visible" : "hidden" }}>
              Mot de passe modifié avec succès
            </div>

            <div className="shadow p-3 mb-5 bg-body rounded">

              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="pb-2">
                  <input
                    id="password1"
                    className="form-control form-control-lg"
                    type="password"
                    onChange={(e) => { setPwd1(e.target.value) }}
                    placeholder="mot de passe"
                    value={pwd1}
                  />
                </div>
                <div className="pt-2 pb-2">
                  <input
                    id="password2"
                    className="form-control form-control-lg"
                    type="password"
                    onChange={(e) => { setPwd2(e.target.value) }}
                    placeholder="répéter mot de passe"
                    value={pwd2}
                  />
                </div>
                <Button type='submit' color='primary' variant="contained" style={btnstyle} fullWidth>Modifier mon mot de passe</Button>
              </form>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-4 text-center">
            <div className="alert alert-danger" role="alert" style={{ visibility: errMsg == 1 ? "visible" : "hidden" }}>
              Les mots de passe doivent correspondre
            </div>
            <div className="alert alert-danger" role="alert" style={{ visibility: errMsg2 == 1 ? "visible" : "hidden" }}>
              Le mot de passe doit contenir au moins un caractère spécial, une majuscule et un chiffre
            </div>
          </div>
        </div>

      </div>

    </ >
  );
}

export default UserProfile;